import { css } from "styled-components";

// Estilo do "field container" (borda + tipografia + destaque de foco) que envolve
// ícone + input. Compartilhado com PhoneNumberInput (components/Form/PhoneNumberInput),
// que precisa do mesmo visual mas injeta um input de terceiros (react-phone-number-input)
// em vez do <input> nativo que `inputCss` estiliza diretamente.
export const fieldContainerCss = css<{ focus: boolean }>`
  display: flex;
  align-items: center;

  border-radius: 10px;
  border: 2px solid var(--color-neutral-light);

  color: var(--color-neutral-white);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: bold;
  line-height: 1rem;
  font-size: 0.875rem;

  padding: 0px;
  padding-left: 16px;
  margin: 8px 0px;
  width: 100%;

  border-color: ${props => props.focus && "var(--color-brand-pink)"};

  + label {
    color: ${props => props.focus && "var(--color-neutral-white)"};
  }

  svg {
    margin-right: 16px;
  }
`;

export const inputCss = css`
  border-radius: 0.625rem;
  padding: 1rem;
  margin: 0.5rem 0;
  width: 100%;

  border: 0.125rem solid var(--color-neutral-light);
  background-color: transparent;

  color: var(--color-neutral-white);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: bold;
  line-height: 1rem;
  font-size: 0.875rem;

  &:focus {
    border-color: var(--color-brand-pink);
    outline: none;
    + label {
      color: var(--color-neutral-white);
    }
  }
`;
